import { makeAutoObservable } from "mobx";
import {
  stopVersionCheck,
  fetchHtml,
  getVersionNumberFromHtml,
} from "./CacheControlService"; // Import the stopVersionCheck function

class CacheControlStore {
  localVersion: string = (window as any).APP_VERSION; // Store the app version
  remoteVersion: string | null = (window as any).APP_VERSION;
  needsUpdate = false; // Track if an update is needed

  constructor() {
    makeAutoObservable(this);
    this.initialVersionCheck();
  }

  initialVersionCheck() {
    fetchHtml().subscribe((html) => { 
      const remoteVersion = getVersionNumberFromHtml(html);
      if (remoteVersion) {
        this.setRemoteVersion(remoteVersion);
      }
    });
  }
  setLocalVersion(version: string) {
    this.localVersion = version;
    this.checkForUpdate();
  }

  setRemoteVersion(version: string) {
    this.remoteVersion = version;
    this.checkForUpdate();
  }

  checkForUpdate() {
    if (this.remoteVersion && this.localVersion !== this.remoteVersion) {
      console.log("Version mismatch detected. Prompting soft refresh...");

      //this.replaceHTMLContent(this.remoteVersion); // Call the function to replace HTML content
      this.needsUpdate = true; // Instead of reloading, update the flag
    }
  }

  replaceHTMLContent = (html: string): void => {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, "text/html");

    // Replace meta tags
    document.querySelectorAll("meta").forEach((meta) => meta.remove());
    newDoc
      .querySelectorAll("meta")
      .forEach((meta) => document.head.appendChild(meta));

    // Replace CSS
    document.querySelectorAll("link[rel='stylesheet']").forEach((el) => {
      const link = el as HTMLLinkElement; // Ensure correct typing
      link.remove();
    });

    newDoc.querySelectorAll("link[rel='stylesheet']").forEach((el) => {
      const newLink = document.createElement("link");
      newLink.rel = "stylesheet";
      newLink.href = (el as HTMLLinkElement).href + "?v=" + Date.now(); // Cache-busting
      document.head.appendChild(newLink);
    });

    // Replace JavaScript
    document.querySelectorAll("script").forEach((el) => {
      const script = el as HTMLScriptElement;
      script.remove();
    });

    newDoc.querySelectorAll("script").forEach((el) => {
      const newScript = document.createElement("script");
      newScript.src = (el as HTMLScriptElement).src + "?v=" + Date.now(); // Cache-busting
      newScript.async = true;
      document.body.appendChild(newScript);
    });
  };

  stopVersionCheck() {
    stopVersionCheck();
    this.needsUpdate = false; // Reset the update flag
  }
}

const appStore = new CacheControlStore();
export default appStore;
